export const EmailRegex =
  /^[a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z0-9]+$/

export const PasswordRegex = /^[a-zA-Z0-9!@#$%^&*,./]+$/

export const CheckHasLowerCaseRegex = /^(?=.*[a-z]).+$/
export const CheckHasUpperCaseRegex = /^(?=.*[A-Z]).+$/

export const checkHasOneNumber = (value: string) => {
  return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].some(
    c => value.indexOf(c) > -1,
  )
}

export const checkHasOneSpecialCharacter = (value: string) => {
  return ["!", "@", "#", "$", "%", "^", "&", "*", ".", ",", "/"].some(
    c => value.indexOf(c) > -1,
  )
}

// ensures one of the required special charecter is there
